export class IncomeConceptModel {
  incomeConceptId: number = 0;
  branchId: number = 0;
  code: number = 0; // Se llena en el backend
  name: string = "";
  incomeAccount: string | null = null;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;

  //variable para controlar si están limpiando el formulario:
  clearForm: boolean = true;
}